import { http, toQuery } from '@/lib/apiClient';

export interface PagedResult<T> { page: number; pageSize: number; totalCount: number; items: T[] }
export interface AuditLogDto { id: number; entityType: string; entityId: string; action: string; performedBy: string; performedAt: string; oldValues: string | null; newValues: string | null; ipAddress: string }
export interface SecurityAuditLogDto { id: number; userId: string | null; username: string; eventType: string; outcome: string; occurredAt: string; ipAddress: string; userAgent: string; details: string | null }

export type AuditPeriod = 'DAY' | 'MONTH' | 'YEAR';
export interface AuditOverviewQuery { period: AuditPeriod; date?: string; entityType?: string; performedBy?: string; page?: number; pageSize?: number }
export interface AuditOverviewMetrics { totalBusinessEvents: number; usersLoggedIn: number; activeUsersNow: number; averageTimeSpentMinutes: number; completedSessions: number; failedLoginAttempts: number }
export interface AuditSessionDto { id: string; userId: string; username: string; fullName: string | null; userType: string; loggedInAt: string; lastSeenAt: string; loggedOutAt: string | null; isActive: boolean; durationMinutes: number; ipAddress: string; userAgent: string }
export interface AuditBusinessLogDto extends AuditLogDto { performedByName?: string | null; entityReference?: string | null }
export interface AuditOverviewDto {
  period: AuditPeriod;
  date: string;
  from: string;
  to: string;
  metrics: AuditOverviewMetrics;
  sessions: AuditSessionDto[];
  businessAuditLogs: PagedResult<AuditBusinessLogDto>;
}

export const auditsApi = {
  business: (query: Record<string, string | number | undefined>) => http.get<PagedResult<AuditLogDto>>(`/api/v1/audit-logs${toQuery(query)}`),
  security: (query: Record<string, string | number | undefined>) => http.get<PagedResult<SecurityAuditLogDto>>(`/api/v1/security-audit-logs${toQuery(query)}`),
  overview: (query: AuditOverviewQuery) => http.get<AuditOverviewDto>(`/api/v1/audit-logs/overview${toQuery({ ...query })}`),
};
